export type DegenCollection = 'Miami' | 'NYC' | 'SDGU' | 'Bitcoin';
export type DegenCollectionNames = 'MiamiDegen' | 'NYCDegen' | 'SDGU StacksPunks' | 'BitcoinDegen';
export const DegenCollectionNamesArr = ['MiamiDegen', 'NYCDegen', 'SDGU StacksPunks', 'BitcoinDegen'];

type DegenCollectionConstMapping = Record<
  DegenCollectionNames,
  { collectionName: DegenCollectionNames; collectionNameShort: DegenCollection; baseSource: string }
>;

export const collectionConstMapping: DegenCollectionConstMapping = {
  MiamiDegen: {
    collectionName: 'MiamiDegen',
    collectionNameShort: 'Miami',
    baseSource: 'https://stxnft.mypinata.cloud/ipfs/QmStnniaoVgxzDiNmqhQR66wMLRH9wMAC62P5RcUFNttGd/',
  },
  NYCDegen: {
    collectionName: 'NYCDegen',
    collectionNameShort: 'NYC',
    baseSource: 'https://stxnft.mypinata.cloud/ipfs/QmSpu1tFB4zamGqKp9urEQsYpZ3ztq64vigXSdpBAFS4qi/',
  },
  'SDGU StacksPunks': {
    collectionName: 'SDGU StacksPunks',
    collectionNameShort: 'SDGU',
    baseSource: 'https://stacksdegens.com/SDGU/StacksPunks/images/',
  },
  BitcoinDegen: {
    collectionName: 'BitcoinDegen',
    collectionNameShort: 'Bitcoin',
    baseSource: 'https://stacksdegens.com/bitcoin-degens/images/',
  },
};
